import {CategoriesDropwdown} from '@/components-v2/common/CategoriesDropdown/CategoriesDropwdown'
import {useProductReview} from '../../../context/ProductReviewContext'
import {ProductReviewData} from '../../ui/ProductReviewData'
import {ProductReviewField} from '../../ui/ProductReviewField'
import {ProductReviewSection} from '../../ui/ProductReviewSection'
import {PRODUCT_REVIEW_CATEGORY_MULTILANGUAGE_SECTION, PRODUCT_REVIEW_CATEGORY_SECTION} from '../productReviewDataMap'
import {SubCategorySection} from './SubCategorySection'

export const CategorySection = () => {
  const {productData, updateEditableField} = useProductReview()
  const categories = productData?.category?.categories ?? []
  const categoryNames = categories.map(category => category?.categoryName).filter(Boolean)

  return (
    <ProductReviewSection title="Category Information" icon="category">
      <ProductReviewData sections={[PRODUCT_REVIEW_CATEGORY_SECTION]} />
      <ProductReviewField
        label="Categories"
        labelKey="categories"
        editable
        required={false}
        renderer="text"
        value={categoryNames}
        customRenderer={(_, onChange) => <CategoriesDropwdown value={categories} onChange={onChange} />}
        onChange={nextValue => updateEditableField('category', 'categories', nextValue)}
      />
      <ProductReviewData sections={[PRODUCT_REVIEW_CATEGORY_MULTILANGUAGE_SECTION]} />
      <SubCategorySection />
    </ProductReviewSection>
  )
}
